<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">Manage {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}</span>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        <button
          mat-raised-button
          color="primary"
          (click)="onSelectSites()"
          class="m-1 mr-2"
          *ngIf="canEditSiteAssociations">
          <mat-icon>location_on</mat-icon> Select {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}
        </button>

        <!-- The mat-menu and its trigger button share one guard. Angular Material renders mat-menu
             content in a CDK overlay, so an unguarded mat-menu leaks into the DOM. -->
        <ng-container *ngIf="canEditSiteAssociations || canDeleteSiteAssociations">
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item (click)="dataSource.selectAllToggle()">
              <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
              {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
            </button>
            <button mat-menu-item (click)="onUnlinkSelectedSites()" [disabled]="!dataSource.selection.hasValue()"
              *ngIf="canDeleteSiteAssociations">
              <mat-icon>link_off</mat-icon> Unlink Selected
            </button>
          </mat-menu>

          <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect {{ utils.getLangTerm('employees.plural', 'Employees') }} managed {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites').toLowerCase() }}." style="min-width: 120px">
            <mat-icon>more_vert</mat-icon>
            List Menu
          </button>
        </ng-container>
      </span>

      <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search"/>

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>
    </div>
  </nav>

  <div class="mat-elevation-z8 scroll-box">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      matSortActive="name"
      matSortDirection="asc"
      matSortDisableClear>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox
            (change)="$event ? dataSource.selectAllToggle() : null"
            [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(row.id) : null"
            [checked]="dataSource.selection.isSelected(row.id)">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Name</th>
        <td mat-cell *matCellDef="let element">
          <b>{{ element.name }}</b> <br />
          <small>{{ element.location }}</small>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="100"></th>
        <td mat-cell *matCellDef="let element">
          <button type="button" mat-button (click)="onUnlinkSite(element.id)"
            *ngIf="canDeleteSiteAssociations">
            Unlink
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [length]="dataSource?.total | async"
      [pageSize]="dataSource.limit"
      [pageSizeOptions]="dataSource.pageSizeOptions"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
